// extracted by mini-css-extract-plugin
export default {"createSpaceDialog":"CreateSpaceDialog-module__createSpaceDialog--YECfV"};